// Apollo 3.x for Vue 3
import { ApolloClient, InMemoryCache, HttpLink } from "@apollo/client/core";
import { DefaultApolloClient } from "@vue/apollo-composable";
import introspectionQueryResultData from "../resources/graphql/fragmentTypes.json";
import AppConfig from "../app-config";

// Create HTTP link
const httpLink = new HttpLink({
  uri: AppConfig.graphQlService,
  credentials: "include",
});

// Create cache with fragment type policy
const cache = new InMemoryCache({
  possibleTypes: introspectionQueryResultData.possibleTypes,
});

// Create the Apollo client
const apolloClient = new ApolloClient({
  link: httpLink,
  cache,
  devtools: { enabled: true },
});

// Create apollo provider for Vue 3
export const apolloProvider = {
  install: (app) => {
    app.provide(DefaultApolloClient, apolloClient);
  },
};

export default apolloClient;
